import _sum from 'lodash/sum'
import _compact from 'lodash/compact'
import _isUndefined from 'lodash/isUndefined'
import { useTranslation } from 'react-i18next'

import * as H from 'hooks'
import * as U from 'utils'
import DashboardCard from '../DashboardCard/DashboardCard'

import { CLASS_NAME } from './const'
import { type Emissions } from 'types/data'

import '../style.scss'

type Props = {
  emissions: Emissions[]
  className?: string
}

export default function TotalArea({
  emissions,
  className
}: Props): JSX.Element {
  const { t } = useTranslation()
  const finalClassName = H.useClassName(CLASS_NAME, className)

  // polygons appear multiple times if there was land cover change,
  // therefore we deduplicate them before calculating the total area
  const dedupedPolygons = Array.from(
    new Map(
      emissions.map((polygon) => [
        polygon.feature.properties.feature_uuid,
        {
          area: polygon.feature.properties.area
        }
      ])
    ).values()
  )

  // prettier-ignore
  const totalArea = dedupedPolygons == null
    ? 0
    : _sum(
      _compact(
        dedupedPolygons.map(({ area }) => _isUndefined(area) ? 0 : area)
      )
    )

  return (
    <DashboardCard
      title={t('metric_card_land_cover.title')}
      value={`${U.formatUINumber(totalArea)} ha`}
      className={finalClassName}
    />
  )
}

export { CLASS_NAME }
